import React from "react";
import { ReactComponent as HomeIcon } from "assets/images/svg-icons/home.svg";
import { ReactComponent as RecentIcon } from "assets/images/svg-icons/recent.svg";
import { ReactComponent as DriveIcon } from "assets/images/svg-icons/drive.svg";
import { ReactComponent as ShareIcon } from "assets/images/svg-icons/sharedwithme.svg";
import { ReactComponent as TrashIcon } from "assets/images/svg-icons/trash.svg";
import { ReactComponent as StarIcon } from "assets/images/svg-icons/starCurrent.svg";
import { ReactComponent as LockedIcon } from "assets/images/svg-icons/lockedCurrent.svg";
import { ReactComponent as HelpIcon } from "assets/images/svg-icons/help-circle-contained.svg";
import { ReactComponent as SettingsIcon } from "assets/images/svg-icons/settings.svg";

export const homeList = ({ t }) => [
  { label: t("common.home"), slug: "home", icon: <HomeIcon /> },
  { label: t("sidebar.recent"), slug: "recent", icon: <RecentIcon /> },
  { label: t("common.starred"), slug: "starred", icon: <StarIcon /> },
  { label: t(t("common.myDrive")), slug: "mydrive", icon: <DriveIcon /> },
  {
    label: t("common.sharedWithMe"),
    slug: "sharedwithme",
    icon: <ShareIcon />,
  },
  { label: t("sidebar.locked"), slug: "locked", icon: <LockedIcon /> },
  { label: t("sidebar.trash"), slug: "trash", icon: <TrashIcon /> },
  { label: t("modal.helpFeedback.helpFeedback"), slug: "helpFeedback", icon: <HelpIcon /> },
  { label: t("setting.settings"), slug: "settings", icon: <SettingsIcon /> },
];

export const settingsList = ({ t }) => [
  { label: t("setting.editProfile"), slug: "editProfile" },
  { label: t("setting.general"), slug: "general" },
  { label: t("setting.notification"), slug: "notification" },
];
